import React from 'react'
import './css/AboutTeam.css'
import TeamImage from './../assets/images/AboutTeam.jpg'

function AboutTeam() {
  return (
    <div className='AboutTeam'>
      <h1 className='head'>Our Team</h1>
      <div className='content'>
        <div className='Image'>
          <img src={TeamImage} alt='Teams' />
        </div>
        <div className='para'>
          <p>Introducing the Master Chefs Behind Keralas Finest Catering Services; Plaza Caterings Dream Team! Our tale of triumph is rooted in work, commitment and culinary mastery. From enthusiasts of farm to table goodness to connoisseurs of gourmet delights our extraordinary team shares a love for creating culinary marvels. With a touch of imagination and a pinch of innovation we curate experiences that go beyond expectations. Sustainability is our ingredient as we expand our business while safeguarding the planet. From inception, to execution our comprehensive event solution takes you on an adventure tailored to perfection. Trust us to bring your vision to life with our attention to every detail.</p>
        </div>
      </div>
    </div>
  )
}

export default AboutTeam